import { ApiEndpoints } from '../../../shared/webservices/endpoint';
import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import RouterUtils from '../../../shared/routing/RouterUtils';

export default class UpdateSchemeDocumentRequest extends GenericRequest {

    schemaDocument;

    constructor(schemaDocumentId, schemaDocument) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.DOCUMENTS_SCHEMAS_ID, { id: schemaDocumentId }));
        this.schemaDocument = schemaDocument;
    }

    overrideRequest() {
        let request = {};
        if ( this.schemaDocument ) request = { ...request, ...this.schemaDocument };
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/schemes/UpdateSchemeDocumentRequest.js